class Games{
  static getInstance(){
    return Games.instance || (Games.instance = new Games());
  }
  constructor(props){
    this.games = {};
    this.historyName = '';
    this.addGame = (name,obj)=>{
      this.games[name] = obj;
    }
    this.gameIsContain =(name)=>{
      if(this.games[name]){
        return true
      }
      return false
    }
    this.getGame = (name)=>{
      return this.games[name];
    }
  }
}
export default Games;